import { createAppTableSaga, createPersist } from 'components/AppTable/store';
import storeTableTaskFactory from 'components/TasksListTabs/storeTableTaskFactory';

export const taskSlice = storeTableTaskFactory({ name: 'tableTasks' as const, onlyTable: false });

export const tasksSaga = createAppTableSaga(taskSlice);

export const tasksReducer = createPersist(taskSlice, ['pagination', 'tabKey']);
